import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "@/router";
import VueAuthenticate from "vue-authenticate";

Vue.use(VueAxios, axios);

const vueAuth = VueAuthenticate.factory(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: "aerweb_token",
  loginUrl: "/login/web"
});

export default {
  state: {
    isAuthenticated: false
  },

  getters: {
    isLoggedIn(state) {
      return state.isAuthenticated;
    }
  },

  mutations: {
    isLoggedIn(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    }
  },

  actions: {
    login(context, payload) {
      return vueAuth.login(payload.user, payload.requestOptions).then(response => {
        context.commit("isLoggedIn", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
        router.push({name: "profile"});
      });
    },
    logout(context, payload) {
      return vueAuth.logout().then(response => {
        context.commit("isLoggedIn", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
      });
    }
  }
};
